import Header from './header/index'
import MyPagination from './my-pagination'
import MaskPage from './mask-page'
import UsPcDialog from './dialog/us-pc-dialog.vue'
import SecrectControl from './secrect/index.vue'
const components = [Header, MyPagination, MaskPage, UsPcDialog,SecrectControl]
const install = Vue => {
  if (install.installed) return
  install.installed = true
  components.map(component => Vue.component(component.name, component))
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/index.js